/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Description({
  marker_long_name, name, date_from, date_to = '', receiver_num, monument_num, station_networks,
  station_contacts, location, iers_domes, cdp_num = '', station_type,
  description = '', monument, geological,
}) {
  return (
    <>
      <div className="metatitle"><span>Station/Monument</span></div>

      <div className="type--container">
        <div className="divborder0">
          <div className="titreprincipale2"><span>Station identification</span></div>
          <p><span className="name">Marker : </span>{marker_long_name}</p>
          <p><span className="name">Site Name : </span>{name}</p>
          <p><span className="name">Installation Date : </span>{date_from}</p>
          <p><span className="name">End Date : </span>{date_to}</p>
          <p><span className="name">Receiver Number : </span>{receiver_num}</p>
          <p><span className="name">Monument Number : </span>{monument_num}</p>
          <p><span className="name">Network : </span> {station_networks.map((networkElem) => `${networkElem.network.name} `)}</p>
          <p><span className="name">Agency : </span>{station_contacts[0].contact.agency.name}</p>
          <p><span className="name">City : </span>{location.city.name}</p>
          <p><span className="name">State : </span>{location.city.state.name}</p>
          <p><span className="name">Country : </span>{location.city.state.country.name}</p>
          <p><span className="name">Latitude : </span>{location.coordinates.lat}</p>
          <p><span className="name">Longitude : </span>{location.coordinates.lon}</p>
          <p><span className="name">Altitude : </span>{location.coordinates.altitude}</p>
          <p><span className="name">X : </span>{location.coordinates.x}</p>
          <p><span className="name">Y : </span>{location.coordinates.y}</p>
          <p><span className="name">Z : </span>{location.coordinates.z}</p>
          <p><span className="name">Iers Domes : </span>{iers_domes}</p>
          <p><span className="name">CDP Number : </span>{cdp_num}</p>
          <p><span className="name">Station type : </span>{station_type.type}</p>
        </div>
        <div className="divborder0">
          <div className="titreprincipale2"><span>Monument and geological information</span></div>
          <p><span className="name">Marker description : </span>{description}</p>
          <p><span className="name">Monument Foundation : </span>{monument.foundation}</p>
          <p><span className="name">Monument Description : </span>{monument.description}</p>
          <p><span className="name">Monument Inscription : </span>{monument.inscription}</p>
          <p><span className="name">Monument Height : </span>{monument.height}</p>
          <p><span className="name">Monument Foundation depth : </span>{monument.foundation_depth}</p>
          <p><span className="name">Geological Characteristic : </span>{geological.characteristic}</p>
          <p><span className="name">Bedrock condition : </span>{geological.bedrock.condition}</p>
          <p><span className="name">Berock type : </span>{geological.bedrock.type}</p>
          <p><span className="name">Fracture spacing : </span>{geological.fracture_spacing}</p>
          <p><span className="name">Fault zone : </span>{geological.fault_zone}</p>
          <p><span className="name">Distance to fault : </span>{geological.distance_to_fault}</p>
          <p><span className="name">Tectonic : </span>{location.tectonic.plate_name}</p>
        </div>
      </div>
    </>
  );
}

Description.propTypes = {
  marker_long_name: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  date_from: PropTypes.string.isRequired,
  date_to: PropTypes.string,
  receiver_num: PropTypes.number.isRequired,
  monument_num: PropTypes.number.isRequired,
  station_networks: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        network: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }),
    ]),
  ).isRequired,
  station_contacts: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        contact: PropTypes.shape({
          agency: PropTypes.shape({
            name: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      }),
    ]),
  ).isRequired,
  location: PropTypes.shape({
    city: PropTypes.shape({
      name: PropTypes.string.isRequired,
      state: PropTypes.shape({
        name: PropTypes.string.isRequired,
        country: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
    coordinates: PropTypes.shape({
      altitude: PropTypes.number.isRequired,
      lat: PropTypes.number.isRequired,
      lon: PropTypes.number.isRequired,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      z: PropTypes.number.isRequired,
    }).isRequired,
    tectonic: PropTypes.shape({
      plate_name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  iers_domes: PropTypes.string.isRequired,
  cdp_num: PropTypes.string,
  station_type: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
  description: PropTypes.string,
  monument: PropTypes.shape({
    description: PropTypes.string.isRequired,
    foundation: PropTypes.string.isRequired,
    foundation_depth: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    inscription: PropTypes.string.isRequired,
  }).isRequired,
  geological: PropTypes.shape({
    bedrock: PropTypes.shape({
      condition: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
    characteristic: PropTypes.string.isRequired,
    distance_to_fault: PropTypes.string.isRequired,
    fault_zone: PropTypes.string.isRequired,
    fracture_spacing: PropTypes.string.isRequired,
  }).isRequired,
};

export default Description;
